<template lang="pug">
.container
  el-header
    h4 {{$t('Failed Requests (last 20 days)')}}
    hr.header
  table(width="100%", v-if='failedRequests.length > 0')
    tr.header-row
      th
        p {{ $t('Player Name') }}&nbsp;
        el-input.el-input(id="SearchByName-searchInput" v-model='playerNameSearch', type="text", name="playerName", ref="playerName", style="width: 30%;", :placeholder="$t('')", size='mini')
      th
        p {{ $t('Method') }}
        el-input.el-input(id="SearchMethodName-searchInput" v-model='methodSearch', type="text", name="method", ref="method", style="width: 30%;", :placeholder="$t('')", size='mini')
      th
        p {{ $t('Arguments') }}
      th
        p {{ $t('Last updated') }}
      th
        p {{ $t('User') }}
      th
        p {{ $t('Response') }}
        el-input.el-input(id="SearchByName-searchInput" v-model='responseSearch', type="text", name="response", ref="response", style="width: 30%;", :placeholder="$t('')", size='mini')
    tr.request-row(v-for='failedRequest in requestsFiltered()', :key='failedRequest.id', :id="'failedRequest'+failedRequest.id")
      td
        p.selectable {{ getFullDeviceNameByDesktopId(failedRequest.DeviceDesktop) }}
      td
        p {{ failedRequest.method }}
      td
        p {{ failedRequest.arguments }}
      td
        p {{ humanTime(failedRequest.updatedAt) }}
      td
        p {{ failedRequest.userId ? failedRequest.userId : '-' }}
      td
        p.selectable {{ failedRequest.responseRaw }}
</template>

<script>
import Vue from 'vue'
import testUtils from '../Common/textUtils.mixin'
import deviceUtils from '../Common/deviceUtils.mixin'
import List from './List'

export default {
  mixins: [testUtils, deviceUtils],
  props: [],
  components: {
    List
  },
  async created () {
    await this.loadData()
  },
  data () {
    return {
      errors: [],
      playerNameSearch: '',
      methodSearch: '',
      responseSearch: '',
      failedRequests: [],
      showResposeVisible: false,
      requestData: ''
    }
  },
  methods: {
    async loadData () {
      this.failedRequests = (await Vue.axios.get('/request/getFailedRequestsForNetwork')).data
    },
    requestsFiltered () {
      let requests = this.failedRequests
      if (this.playerNameSearch.length > 0) {
        requests = this.failedRequests
          .filter(fr => fr.name.toLowerCase().indexOf(this.playerNameSearch.toLowerCase()) > -1)
      }
      if (this.methodSearch.length > 0) {
        requests = this.failedRequests
          .filter(fr => fr.method.toLowerCase().indexOf(this.methodSearch.toLowerCase()) > -1)
      }
      if (this.responseSearch.length > 0) {
        requests = this.failedRequests
          .filter(fr => JSON.stringify(fr.responseRaw).toLowerCase().indexOf(this.responseSearch.toLowerCase()) > -1)
      }
      return requests
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.error {
  color: $--color-warning;
}
.save-button {
  margin: 10px 0px;
}
.title {
  display: flex;
  .save-button {
    margin-left: auto;
  }
}
.row {
  padding: 10px 10px;
  border-bottom:  $--border-light;
  cursor: pointer;
  color: $--color-text-primary;
  font-size: $--font-size-base;
  display: flex;
  align-items: center;
}
table {
  padding: 0px;
  border-spacing: 0px;
  th, td {
    text-align: left;
    width: 20%;
  }
  .request-row {
    td {
      border-bottom: $--border-light;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Device/FailedRequests.vue